import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";

import type {DashboardEmailByModel} from "../types";

type EmailByModelListProps = {
  rows: DashboardEmailByModel[];
};

/**
 * Operational view of email performance per source model. Rendered as a
 * compact table because the value is row-by-row comparison, not totals.
 */
export function EmailByModelList({rows}: EmailByModelListProps) {
  return (
    <Card className="gap-3 py-4">
      <CardHeader>
        <CardTitle className="text-sm font-semibold">By source</CardTitle>
      </CardHeader>
      <CardContent>
        {rows.length === 0 ? (
          <p className="text-muted-foreground text-sm">No email activity recorded.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-muted-foreground text-xs">
                  <th className="px-2 py-1.5 text-left font-medium">Source</th>
                  <th className="px-2 py-1.5 text-right font-medium">Delivered</th>
                  <th className="px-2 py-1.5 text-right font-medium">Opened</th>
                  <th className="px-2 py-1.5 text-right font-medium">Clicked</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => {
                  const openRate =
                    row.delivered > 0 ? (row.opened / row.delivered) * 100 : 0;
                  return (
                    <tr key={`${row.model_type || "source"}-${index}`} className="border-border border-t">
                      <td className="px-2 py-2 font-medium">{row.label ?? row.model_type}</td>
                      <td className="px-2 py-2 text-right tabular-nums">
                        {row.delivered.toLocaleString()}
                      </td>
                      <td className="px-2 py-2 text-right tabular-nums">
                        {row.opened.toLocaleString()}
                        <span className="text-muted-foreground ml-1 text-xs">
                          ({openRate.toFixed(0)}%)
                        </span>
                      </td>
                      <td className="px-2 py-2 text-right tabular-nums">
                        {row.clicked.toLocaleString()}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
